import type { Query, QueryOrderArgs } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { ORDER } from './gql/order';

type QueryDataType = Pick<Query, 'order'>;
type OutgoingDataType = QueryDataType['order'] | undefined;

const onError = getErrorLoggerFunction('order');

export const useOrder = (orderNumber: string) => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { loading, data, error, refetch } = useQuery<QueryDataType, QueryOrderArgs>(ORDER, {
        variables: {
            orderNumber
        },
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.order);
        }
    }, [data]);

    return {
        order: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
